// Centralized constants for the Action Center feature.
// Import these instead of using hardcoded strings throughout the codebase.

export const BOOK_VIEWS = Object.freeze({
  ALL: 'all',
  HIGH_RISK: 'high-risk',
  INCOMPLETE_ACTIONS: 'incomplete-actions',
  INCOMPLETE_ASSESSMENTS: 'incomplete-assessments',
  UPCOMING_REQUIREMENTS: 'upcoming-requirements',
  REQUIREMENTS_BY_TYPE: 'requirements-by-type',
  REQUIREMENTS_BY_EMPLOYER: 'requirements-by-employer'
})

export const BOOK_VIEWS_LIST = Object.freeze(Object.values(BOOK_VIEWS))

// Views that render the BookRequirementDeadlines component
export const DEADLINE_VIEWS = Object.freeze([
  BOOK_VIEWS.UPCOMING_REQUIREMENTS,
  BOOK_VIEWS.REQUIREMENTS_BY_TYPE,
  BOOK_VIEWS.REQUIREMENTS_BY_EMPLOYER
])

// Views that render the BookAllEmployersView (employer table) component
export const EMPLOYER_TABLE_VIEWS = Object.freeze([
  BOOK_VIEWS.ALL,
  BOOK_VIEWS.HIGH_RISK,
  BOOK_VIEWS.INCOMPLETE_ACTIONS,
  BOOK_VIEWS.INCOMPLETE_ASSESSMENTS
])

export const DEFAULT_VIEW = BOOK_VIEWS.ALL
